import businessesIcon from './businesses.png';
import educationalInstitutesIcon from './educational-institutes.png';
import manufacturingFirmsIcon from './manufacturing-firms.png';
import individualIcon from './individual.png';
import serviceProvidersIcon from './service-providers.png';
import otherInstitutesIcon from './other-institutes.png';

export const whoShouldBuyIcons = {
  businessesIcon,
  educationalInstitutesIcon,
  manufacturingFirmsIcon,
  individualIcon,
  serviceProvidersIcon,
  otherInstitutesIcon,
};
